"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIllustration = _interopRequireDefault(require("../withIllustration"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IllustrationTownHouseComposition = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 256 159",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#10105A",
            x: "0",
            y: "155",
            width: "256",
            height: "4",
            rx: "2"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M145.892336,25.5561244 C131.339846,25.0419533 117.478419,20.2483579 104.243769,15.0046128 C91.0091187,9.76086764 77.8970118,3.94893339 63.6940708,1.17000855 C54.5575821,-0.616586035 44.1092799,-0.86866993 36.748661,4.12699265 C29.6632617,8.92859065 27.3751217,17.2393565 26.1456733,24.9339173 C25.2195693,30.7358482 24.6751567,36.8278757 27.2103917,42.2536814 C28.9721992,46.0209352 32.1000605,49.1859885 34.2636485,52.793189 C41.7869886,65.3473671 36.4734413,80.8285194 28.3132792,93.0865989 C24.4963644,98.8365125 20.050663,104.322338 17.0995852,110.442375 C14.1485073,116.562412 12.7824536,123.576746 15.3638934,129.820824 C17.9252441,136.010884 24.0242723,140.658431 30.6315527,143.927519 C44.0530306,150.56973 59.8691204,152.470362 75.2914652,153.54672 C109.430755,155.929513 143.752855,154.89717 177.982546,153.864826 C190.650685,153.480698 203.373065,153.09457 215.836296,151.095905 C222.754957,149.985535 229.898614,148.224949 234.92087,143.971534 C241.299136,138.569736 242.880142,129.432695 238.605198,122.664443 C231.44346,111.314665 211.621619,108.497728 206.611416,96.3096716 C203.853193,89.6034397 206.685745,82.1329535 210.693506,75.9028801 C219.291609,62.5604396 233.703475,50.8545438 234.462841,35.6014675 C234.985155,25.1259812 228.05645,14.6344896 217.344982,9.67884034 C206.115217,4.47710917 190.546222,5.1373289 182.261508,13.7361906 C173.731708,22.6051423 158.741277,26.0122762 145.892336,25.5561244 Z",
            className: "fill-primary",
            fill: "#1657E2",
            fillRule: "nonzero",
            opacity: "0.1"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            className: "fill-primary",
            transform: "translate(73.000000, 55.000000)",
            fill: "#0842C0",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M19.6670115,0 C36.285725,33.3333333 42.4395712,58.3333333 38.12855,75 C27.8368233,75 17.5502984,75 1.20547307,75 C-2.84423669,58.3333333 3.30960946,33.3333333 19.6670115,0 Z"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            opacity: "0.495837984",
            className: "fill-primary",
            transform: "translate(93.000000, 55.000000)",
            fill: "#0842C0",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M19.6670115,0 C36.285725,33.3333333 42.4395712,58.3333333 38.12855,75 C27.8368233,75 17.5502984,75 1.20547307,75 C-2.84423669,58.3333333 3.30960946,33.3333333 19.6670115,0 Z"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(10.000000, 31.000000)",
            className: "fill-secondary",
            fill: "#10105A",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
              cx: "20",
              cy: "20",
              r: "20"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(18.000000, 98.000000)",
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#FFFFFF",
                x: "0",
                y: "22.8",
                width: "57.6315789",
                height: "34.2"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                fill: "#091E43",
                points: "17.2894737 0 74.9210526 0 57.6315789 22.8 0 22.8"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                fill: "#C3D0D8",
                points: "57.6315789 22.8 74.9210526 0 92.2105263 22.8 92.2105263 57 57.6315789 57"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "34.5789474",
                y: "34.2",
                width: "11.5263158",
                height: "11.4"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "11.5263158",
                y: "34.2",
                width: "11.5263158",
                height: "22.8"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#FFFFFF",
                x: "63.3947368",
                y: "22.8",
                width: "57.6315789",
                height: "34.2"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                fill: "#091E43",
                points: "80.6842105 0 138.315789 0 121.026316 22.8 63.3947368 22.8"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                fill: "#C3D0D8",
                points: "121.026316 22.8 138.315789 0 155.605263 22.8 155.605263 57 121.026316 57"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "97.9736842",
                y: "34.2",
                width: "11.5263158",
                height: "11.4"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "74.9210526",
                y: "34.2",
                width: "11.5263158",
                height: "22.8"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#FFFFFF",
                x: "126.789474",
                y: "22.8",
                width: "57.6315789",
                height: "34.2"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                fill: "#091E43",
                points: "144.078947 0 201.710526 0 184.421053 22.8 126.789474 22.8"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                fill: "#C3D0D8",
                points: "184.421053 22.8 201.710526 0 219 22.8 219 57 184.421053 57"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "161.368421",
                y: "34.2",
                width: "11.5263158",
                height: "11.4"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#091E43",
                x: "195.947368",
                y: "34.2",
                width: "11.5263158",
                height: "11.4"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "138.315789",
                y: "34.2",
                width: "11.5263158",
                height: "22.8"
              })]
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(8.000000, 145.000000)",
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M0,0 L0.295900454,0.0047585308 C5.30742742,0.166156746 9.34215109,4.4132343 9.4954794,9.68852584 L9.5,10 L9.20409955,9.99524147 C4.19257258,9.83384325 0.157848909,5.5867657 0.00452060426,0.311474163 L0,0 Z",
                className: "fill-primary",
                fill: "#1657E2"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M19,0 L18.9954794,0.311474163 C18.8452177,5.48125987 14.9672638,9.66354887 10.0953967,9.98067922 L9.79590045,9.99524147 L9.5,10 L9.5045206,9.68852584 C9.65478234,4.51874013 13.5327362,0.336451134 18.4046033,0.0193207792 L18.7040995,0.0047585308 L19,0 Z",
                className: "fill-primary-opa50",
                fill: "#779DED"
              })]
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            className: "fill-primary",
            transform: "translate(185.000000, 141.000000)",
            fill: "#1657E2",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M0,14 C0,8.84534234 4.27816795,4.66666667 9.55555556,4.66666667 C12.0996841,4.66666667 14.4115919,5.63779985 16.1239165,7.22124707 C18.5666974,2.91514045 23.2681427,0 28.6666667,0 C36.4609622,0 42.8021913,6.0766351 42.9954613,13.6441961 L43,14 L0,14 Z"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(34.000000, 41.000000)",
            fill: "#FFFFFF",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M43,14 C43,8.84534234 38.7218321,4.66666667 33.4444444,4.66666667 C30.9003159,4.66666667 28.5884081,5.63779985 26.8760835,7.22124707 C24.4333026,2.91514045 19.7318573,0 14.3333333,0 C6.53903779,0 0.197808658,6.0766351 0.00453871899,13.6441961 L0,14 L43,14 Z"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(196.000000, 65.000000)",
            fill: "#FFFFFF",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M43,14 C43,8.84534234 38.7218321,4.66666667 33.4444444,4.66666667 C30.9003159,4.66666667 28.5884081,5.63779985 26.8760835,7.22124707 C24.4333026,2.91514045 19.7318573,0 14.3333333,0 C6.53903779,0 0.197808658,6.0766351 0.00453871899,13.6441961 L0,14 L43,14 Z"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(163.500000, 40.000000) scale(-1, 1) translate(-163.500000, -40.000000) translate(142.000000, 33.000000)",
            fill: "#FFFFFF",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M43,14 C43,8.84534234 38.7218321,4.66666667 33.4444444,4.66666667 C30.9003159,4.66666667 28.5884081,5.63779985 26.8760835,7.22124707 C24.4333026,2.91514045 19.7318573,0 14.3333333,0 C6.53903779,0 0.197808658,6.0766351 0.00453871899,13.6441961 L0,14 L43,14 Z"
            })
          })]
        })
      })
    })
  });
};
var _default = exports.default = (0, _withIllustration.default)('IllustrationTownHouseComposition')(IllustrationTownHouseComposition);